import { useState, useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';

export const useGroupPositions = (groupId, enabled = true) => {
    const [positions, setPositions] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const { getAccessTokenSilently } = useAuth0();
    const apiUrl = process.env.REACT_APP_API_URL;

    useEffect(() => {
        const fetchGroupPositions = async () => {
            if (!enabled || !groupId) {
                setLoading(false);
                return;
            }

            try {
                const token = await getAccessTokenSilently({
                    authorizationParams: {
                        audience: process.env.REACT_APP_API_AUDIENCE,
                    },
                });
                const response = await fetch(`${apiUrl}/api/Positions/group/${groupId}`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });

                if (!response.ok) {
                    throw new Error('Failed to fetch group positions');
                }

                const data = await response.json();
                setPositions(data);
                setLoading(false);
            } catch (err) {
                setError(err.message);
                setLoading(false);
            }
        };

        fetchGroupPositions();
    }, [enabled, groupId, getAccessTokenSilently, apiUrl]);

    return { positions, loading, error };
};
